import { Model } from "./model";

export class VerificationApplication extends Model {
	private availability: AvailabilityItem[] = [];
	private display_name: string = "";
	private name: string = "";
	private sort: number = -1;
	private token: string = "";
	private url: string = "";
	private logo: string = "";
	private logo_dark: string = "";
	private verification_scope: string = "";
	private estimated_waiting_time = "n/a";

	public getDisplayName(): string {
		return this.display_name;
	}

	public getName(): string {
		return this.name;
	}

	public getUrl(): string {
		return this.url;
	}

	public getLogo(): string {
		return this.logo;
	}

	public getAvailability(): AvailabilityItem[] {
		return this.availability;
	}

	public getToken(): string {
		return this.token;
	}

	public getLogoDark(): string {
		return this.logo_dark;
	}
}

class AvailabilityItem extends Model {
	public available: boolean = false;
	public language: string = "";
	public timetable: TimetableItem = new TimetableItem();
}

class TimetableItem extends Model {
	public weekday_start_time: string = "";
	public weekday_end_time: string = "";
	public saturday_start_time: string = "";
	public saturday_end_time: string = "";
	public sunday_start_time: string = "";
	public sunday_end_time: string = "";
}
